import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class BusinessFunctionCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }
    items = () => { return this.state.items; }
    
	componentDidMount = () => {
		this._isMounted = true;

		API.Certification.get('/query/getBusinessFunctions', {},
			{
				success: (r) => {
					this._isMounted && this.setState({
						items: r.data.items.map((item) => { return { label: item.businessFunctionName, value: item.businessFunctionId } })
					});
				}
			},
			{ block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select..."}
                items={this.state.items}
                searchable={false}
                ref={(c) => { this._ctrl = c}} />
        )
    }
}

export default BusinessFunctionCombo;

// Mark this as a form component
BusinessFunctionCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/businessFunctionCombo/BusinessFunctionCombo.js